<template>
  <div class="centerBox">
    <div id="main" class="index centBoxIn">
      <topCarousel :banners="bannerList" />
      <introduceGYZ />
      <div class="news">
        <div
          class="news-iner"
          v-if="newsList.length || centList.length || activList.length"
        >
          <div class="comp-news">
            <div class="new-title">
              <div class="news-title-txt">公司动态</div>
              <div class="news-title-btn" @click="moreNews(0)">更多</div>
            </div>
            <div class="betweenImgBox">
              <img class="between-img" :src="newsList[0].cover_pictures" />
            </div>
            <div class="news-list" v-if="newsList && newsList.length">
              <div class="news-item-box" v-for="item in newsList" :key="item.id">
                <div class="news-item" @click="jumpDetail(item.id)">{{ item.title }}</div>
              </div>
            </div>
          </div>
          <div class="comp-cent" v-if="centList.length">
            <div class="centImgBox">
              <img class="cent-img" :src="centList[0].cover_pictures" />
            </div>
            <div class="cent-list" v-if="centList && centList.length">
              <div
                class="news-item"
                @click="jumpDetail(item.id)"
                v-for="item in centList"
                :key="item.id"
              >
                {{ item.title }}
              </div>
            </div>
            <div class="cent-btn" @click="jumpDetail(centList[0].id)" />
          </div>
          <div class="comp-activity">
            <div class="new-title">
              <div class="news-title-txt">产品活动</div>
              <div class="news-title-btn" @click="moreNews(1)">更多</div>
            </div>
            <div class="betweenImgBox">
              <img class="between-img" :src="activList[0].cover_pictures  " />
            </div>
            <div class="news-list" v-if="activList && activList.length">
              <div class="news-item-box" v-for="item in activList" :key="item.id">
                <div class="news-item" @click="jumpDetail(item.id)">{{ item.title }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="orgData">
        <div class="contInner">
          <div class="contInnerBox">
            <div class="countItem" v-for="item in orgData" :key="item.desc">
              <div class="count">{{ item.count }}</div>
              <div class="desc">{{ item.desc }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TopCarousel from "@/components/TopCarousel";
import IntroduceGYZ from "@/components/IntroduceGYZ";

import { getBanners } from "@/utils/tool";
import { getArticleList } from "@/api/news";
import { getTopArticle } from "@/api/home.js";
import { mapState } from "vuex";
import { getNavList } from "@/api/topNav";

export default {
  name: "index",
  components: { IntroduceGYZ, TopCarousel },
  data() {
    return {
      bannerList: [],
      newsList: [],
      centList: [],
      activList: [],
      orgData: [
        { count: "600,000+", desc: "累计超算量" },
        { count: "400,00+", desc: "数据解析次数" },
        { count: "500,00+", desc: "资金运算次数" },
        { count: "100%+", desc: "数据覆盖量" },
      ],
    };
  },
  mounted() {
    window.scrollTo(0, 0);
    this.getArtList();
  },
  methods: {
    getArtList() {
      // 获取资讯动态下的二级菜单
      let tabList = this.navList
        ? this.navList.find((item) => item.name == "资讯动态").class
        : [];
      if (tabList.length == 0) {
        // 首次加载
        const navRes = getNavList().then((navRes) => {
          if (navRes.code === 200) {
            const navListIn = navRes.data;
            let _tabList = navListIn.find((item) => item.name == "资讯动态").class;
            localStorage.setItem("navList", JSON.stringify(navRes.data));
            this.getArticleCont(_tabList);
            this.bannerList = getBanners("/index");
          }
        });
      } else {
        this.getArticleCont(tabList);
        this.bannerList = getBanners("/index");
      }
    },
    getArticleCont(tabList) {
      const promiList = [];
      tabList.forEach((itemClass, index) => {
        const { id } = itemClass;
        const tabQuery = itemClass.path.split("?")[1];
        if (!tabQuery) return;
        const tabInd = tabQuery[tabQuery.length - 1];
        promiList[index] = getArticleList(id, {pageSize: 6});
      });

      Promise.all(promiList).then((resList) => {
        resList.forEach((res, ind) => {
          switch (ind) {
            case 0:
              // 公司动态
              this.newsList = res.data.list;
              break;
            case 1:
              // 产品活动
              this.activList = res.data.list;
              break;
          }
        });
      });
      // 获取置顶文章
      getTopArticle().then((res) => {
        if (res.code == 200 && res.data) {
          this.centList = [res.data];
        }
      });
    },
    jumpDetail(id) {
      this.$router.push({
        path: "/newsDetail",
        query: {
          id,
        },
      });
    },

    moreNews(tabName) {
      this.$router.push({ path: "/news?tab=" + tabName });
    },
  },
  computed: {
    ...mapState(["navList"]),
  },
};
</script>

<style scoped>
.index .news {
  width: 100%;
  background-color: #fff;
  display: flex;
  justify-content: center;
}
.index .news-iner {
  width: var(--content-width);
  min-width: var(--content-min-width);
  min-height: 800px;
  padding: 150px 20px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
}
.index .news-iner .comp-cent {
  padding-top: 78px;
 /*  padding-left: 10px;
  padding-right: 10px; */
  text-align: left;
}
.index .news-iner .comp-news {
  padding-right: 10px;
}
.index .news-iner .comp-activity {
  padding-left: 10px;
}

.index .news-iner > .comp-cent {
  flex: 1.5;
}
.index .news-iner > .comp-news,
.index .news-iner > .comp-activity {
  flex: 1;
}

.index .news-iner .new-title {
  width: 100%;
  font-weight: 800;
  font-size: 29px;
  color: #1a1a1a;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 36px;
}
.index .news-iner .new-title .news-title-btn {
  cursor: pointer;
  color: #398fff;
  font-size: 17px;
  border-radius: 2px 2px 2px 2px;
  border: 2px solid #398fff;
  padding: 6px 25px;
  box-sizing: border-box;
}
.index .news-iner .new-title .news-title-btn:active,
.index .news-iner .new-title .news-title-btn:hover {
  color: #fff;
  padding: 8px 27px;
  border: none;
  background: linear-gradient(90deg, #1c58f4 0%, #398fff 100%);
}
.comp-cent .cent-btn:active,
.comp-cent .cent-btn:hover {
  background-size: cover;
  background-image: url("../../common/images/other/more_active.png");
  background-position: center;
  background-repeat: no-repeat;
}
.index .news-iner .betweenImgBox {
  overflow: hidden;
  position: relative;
  padding-top: 56.25%;
  width: 100%;
}
.index .news-iner .between-img {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
}
.index .comp-cent .cent-img,
.index .news-iner .between-img {
  transform: scale(1);
  transition: all 0.2s;
}
.index .comp-cent .cent-img:hover,
.index .news-iner .between-img:hover {
  transform: scale(1.05);
}

.index .news-iner .cent-list,
.index .news-iner .news-list {
  font-weight: 500;
  font-size: 25px;
  color: #1a1a1a;
  text-align: left;
}
.index .news-iner .cent-list .news-item {
  cursor: pointer;
}
.comp-cent .cent-btn {
  display: inline-block;
  margin-top: 12px;
  cursor: pointer;
  width: 56px;
  height: 35px;
  background: url("../../common/images/other/more.png") no-repeat center;
  background-size: contain;
}
.news-iner .news-list .news-item-box {
  margin-top: 11px;
  padding-bottom: 12px;
  border-bottom: 2px solid #f5f5f5;
}
.news-iner .centImgBox {
  overflow: hidden;
  position: relative;
  padding-top: 56.25%;
  width: 100%;
}
.news-iner .cent-img {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
}
.news-iner .news-list .news-item {
  cursor: pointer;
  line-height: 37px;

  /* 超出俩行省略号 */
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.orgData {
  background: url("../../common/images/index/dataCountBg.png") no-repeat center;
  background-size: 100% 100%;
  width: 100%;
  height: 248px;
}
.contInner {
  width: var(--content-width);
  min-width: var(--content-min-width);
  height: 100%;
  margin: 0 auto;
  padding: 0 20px;
  box-sizing: border-box;
}
.contInnerBox {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 100%;
}
.orgData .countItem {
  color: #fff;
}
.orgData .countItem .count {
  font-weight: 800;
  font-size: 43px;
  text-align: center;
}
.orgData .countItem .desc {
  font-weight: 500;
  font-size: 25px;
  color: #f0f9fc;
}
</style>



// WEBPACK FOOTER //
// src/views/home/index.vue